import {getBridgedTeeth, getToothPosition, getToothIndex} from "../components/common/teeth"
import React from "react"

export const getTotalItems =  (teeth,bridges)=>{
    return teeth.filter(item=>item.material).length + bridges.filter(item=>!item.bridgeProcess).length;
}

export const getImplantPrice = (tooth,currency)=>{
    const prices = abraProds.find(prods=>prods.type === "crown" && prods.material === tooth.material);
    return prices?.[currency] || 0;
}

export const getCurrencySign = (currency)=> currency === "dollars"? "$" : "₪";

const getPriceByCurrency = (prices,currency)=> prices?.[currency] || 0;

export const getBridgePrice=(teeth,currency,bridge)=>{

    const {bridgeType} = bridge;
    const isOverDenture  = bridgeType === "overDenture";

    const inRange = getBridgedTeeth(bridge.teeth[0],true);
    let price = 0;
    const implantPrices =  abraProds.find(prods=>prods.type === "implant");
    const superStructurePrices =  abraProds.find(prods=>prods.type === "superstructure");
    const crownPrices = abraProds.find(prods=>prods.type === "crown" && prods.material === bridge.material);
    const teethToCalculate = inRange.map(toothInRange=>teeth.find(tooth=>tooth.id === toothInRange));

    console.log("-----preparing bridge pricing------");

    if(isOverDenture){
        const {overDentureType} = bridge;
        if(overDentureType === "whole"){
            const fullArchPrices =  abraProds.find(prods=>prods.type === "full-arch" && prods.material === bridge.material);
            price += getPriceByCurrency(fullArchPrices,currency);
            console.log(`${bridge.material} full arch`);
        }else{
            const partial = abraProds.find(prods=>prods.type === "partial" && prods.material === bridge.material);
            price += getPriceByCurrency(partial,currency);
            console.log(`${bridge.material} partial`);
        }

    }
    teethToCalculate.forEach(tooth=> {
        console.log(`--- Tooth: ${tooth.id}`)

        if(!isOverDenture && !tooth.isTelescopicCrown && tooth.state !== "abutment"){
            price += getPriceByCurrency(crownPrices,currency);
            console.log(`${bridge.material} crown`);
        }
       if(tooth.state ===  "implant" && !tooth.isTelescopicCrown) {
           price += getPriceByCurrency(implantPrices,currency);
           price += getPriceByCurrency(superStructurePrices,currency);
           console.log(`Implant + superstructure`);

       }else if(tooth.state ===  "abutment"){
           const telescopicCapePrices = abraProds.find(prods=>prods.type === "telescopic-cap" && prods.material === tooth.telescopicCap);
           price += getPriceByCurrency(telescopicCapePrices,currency);
           console.log(`${tooth.telescopicCap} telescopic cap`);
       }
    });

    return price;
}

export const getTotalPrice =  (teeth,currency,bridges,clean)=>{

    let price = 0;
    teeth.filter(tooth=>tooth.state === "implant" && tooth.isTelescopicCrown).forEach(tooth=>{
        price += getImplantPrice(tooth,currency);
    });
    if(bridges.length){
        bridges.forEach(bridge=>{
            price += getBridgePrice(teeth,currency,bridge);
        });
    }

    return price && `${!clean? ((currency === "dollars")? "$" : "₪") : ""}${price}`;
}

export const getAdditionalInformationForDB = (fields)=>
        `
        <strong>DOCTOR</strong><br/>
        First Name: ${fields["docFirsName"]}<br/>
        Last Name: ${fields["docLastName"]}<br/>
        Email: ${fields["docEmail"]}<br/>
        Country: ${fields["country"]}<br/><br/>
         <strong>Client</strong><br>
        First Name: ${fields["firsName"]}<br/>
        Last Name: ${fields["lastName"]}<br/>
        Gender: ${fields["gender"]}<br/>
        Date of birth: ${fields["birth"]}<br/>
    `;

export const getOrderDescriptionForDB = (teethState,currency,bridges)=>{

    let description = "";
    teethState
        .filter(tooth=>tooth.state === "implant" && tooth.isTelescopicCrown)
        .map(tooth=>{
            description += `
                Telescopic Crown Item<br/>
                Type: Telescopic Crown<br/>
                Material: ${tooth.material}<br/>
                Teeth: 1(${tooth.id})<br/>
                Implants: 1(${tooth.id})<br/>
                Price: ${getCurrencySign(currency)}${getImplantPrice(tooth,currency)}<br/><br/>
            `;
        });
    bridges.map((bridge,index)=> {
        let bridgeTeethLength = 0;
        let bridgeImplants = [];
        let bridgeRanges = [];
        bridge.teeth.map(range=>{
            const bridgeTeeth  = getBridgedTeeth(range,true);
            bridgeTeethLength += bridgeTeeth.length;
            const teethWithIndices = {};
            const position = getToothPosition(range);
            const teethIndices = bridgeTeeth.map(tooth=> {
                const index = getToothIndex(position, tooth);
                teethWithIndices[index] =  tooth;
                return index;
            });
            const [firstTeethInBridge, lastTeethInBridge] = [ Math.min(...teethIndices),Math.max(...teethIndices)]
            const implants = bridgeTeeth.filter(bridgeTooth=>
                teethState.find(tooth=>
                    tooth.id === bridgeTooth
                ).state === "implant"
            );
            bridgeImplants = [...bridgeImplants,...implants];
            bridgeRanges = [...bridgeRanges,[teethWithIndices[firstTeethInBridge], teethWithIndices[lastTeethInBridge]] ];
        });
        const teethRangesString =  bridgeRanges.map((range,index)=>
            `${index? " ;":""}${range[0]}-${range[1]}`
        )

        let implantDEsc = "";
        bridgeImplants && bridgeImplants.map((tooth,index)=> {
            implantDEsc +=  `${tooth}${index < bridgeImplants.length - 1 ? "; " : ""}`
        })

        description += `
                ${bridge.bridgeType === "telescopic"? "Telescopic Bridge" : "Telescopic Overdenture"} Item<br/>
                Material: ${bridge.material}<br/>
                Teeth: ${bridgeTeethLength}(${teethRangesString})<br/>
                Implants: ${bridgeImplants.length}(${implantDEsc})<br/>
                Price: ${getCurrencySign(currency)}${getBridgePrice(teethState,currency,bridge)}<br/><br/>
            `;
    });

    return description;

}
